export default __webpack_public_path__ + "static/2019_09-c5a51ce784fb9c12c08d62237612e75d.png";